"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopPoliciesInteractor = void 0;
const core_1 = require("@veeam/core");
const rxjs_1 = require("rxjs");
require("./..");
const core_2 = require("../../../../core");
const constants_1 = require("../constants");
require("./TopPoliciesDataGridModel");
class TopPoliciesInteractor extends core_1.Interactor {
    constructor(dataGridModel, durationFilterModel, typeFilterModel, presenters) {
        super();
        this.dataGridModel = dataGridModel;
        this.durationFilterModel = durationFilterModel;
        this.typeFilterModel = typeFilterModel;
        this.presenters = presenters;
        this.subscriptions = new rxjs_1.Subscription();
        this.LOCAL_STORAGE_FILTER_KEY = 'policyWidget|filter';
        this.LOCAL_STORAGE_SORT_KEY = 'policyWidget|sort';
        this.timerId = null;
        this.dataGridModel = dataGridModel;
        this.durationFilterModel = durationFilterModel;
        this.typeFilterModel = typeFilterModel;
        this.presenters = presenters;
    }
    didActivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.presenters.setLoading(true);
            this.subscriptions.add(rxjs_1.merge(this.durationFilterModel.fieldChanges('sort'), this.typeFilterModel.fieldChanges('type')).subscribe(() => __awaiter(this, void 0, void 0, function* () {
                const sortValue = this.durationFilterModel.getValue().sort;
                const typeValue = this.typeFilterModel.getValue().type;
                this.dataGridModel.setFilter('sort', { value: sortValue });
                this.dataGridModel.setFilter('type', { value: typeValue });
                core_2.appStorage.setItem(this.LOCAL_STORAGE_FILTER_KEY, typeValue);
                core_2.appStorage.setItem(this.LOCAL_STORAGE_SORT_KEY, sortValue);
                this.dataGridModel.load();
            })));
            this.presenters.setLoading(false);
        });
    }
    willActivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.presenters.setLoading(true);
            const initialDurationValue = core_2.appStorage.getItem(this.LOCAL_STORAGE_SORT_KEY);
            const initialTypeValue = core_2.appStorage.getItem(this.LOCAL_STORAGE_FILTER_KEY);
            if (initialDurationValue) {
                this.durationFilterModel.setValue({ sort: initialDurationValue });
                this.dataGridModel.setFilter('sort', { value: initialDurationValue });
            }
            if (initialTypeValue) {
                this.typeFilterModel.setValue({ type: initialTypeValue });
                this.dataGridModel.setFilter('type', { value: initialTypeValue });
            }
            this.timerId = window.setInterval(() => {
                return this.dataGridModel.sync();
            }, constants_1.REFRESH_DATA_INTERVAL);
            this.dataGridModel.load();
            this.presenters.setLoading(false);
        });
    }
    willDeactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.timerId) {
                window.clearInterval(this.timerId);
            }
            this.dataGridModel.destroy();
            this.subscriptions.unsubscribe();
        });
    }
}
exports.TopPoliciesInteractor = TopPoliciesInteractor;
//# sourceMappingURL=TopPoliciesInteractor.js.map